<template xmlns="http://www.w3.org/1999/html">
  <div class="container-wrapper">
    <img src="@/assets/PremiosRanking.svg" alt="" class="heading">
    <div class="content">
      <div class="wrapper">
        <h3 class="title" style="font-size: 32px">¡Gana Premios Diariamente!</h3><br>
        <h3 class="title" style="font-size: 32px; padding-bottom: 32px">8 - 11 Marzo / Diagonal Mar - Planta Baja - Plaza Central</h3><br>
      </div>
    </div>
    <div class="content" style="text-align: center">
      <div class="wrapper">
        <img src="@/assets/p4.png" alt="" class="thumbnail">
        <h3 class="title">GIFT CARD 50€ / DIA <br>AL MVP DIARIO</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">MVP - Max. Goles</p>
      </div>
      <div class="wrapper">
        <img src="@/assets/p4.png" alt="" class="thumbnail">
        <h1></h1>
        <h3 class="title">GIFT CARD 40€ / DIA</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">TOP 5 Diario</p>
      </div>
    </div>
    <div class="content">
      <div class="wrapper">
        <br>
        <br>
        <h3 class="title" style="font-size: 45px; padding-top: 40px; padding-bottom: 32px">PREMIOS RANKING GENERAL</h3>
      </div>
    </div>
    <div class="content" style="text-align: center">
      <div class="wrapper">
        <img src="@/assets/p1.png" alt="" class="thumbnail">
        <h3 class="title">PLAYSTATION 5</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">El ganador del ranking semanal ganará una Playstation 5</p><br>
      </div>
    </div>
    <div class="content" style="text-align: center">
      <div class="wrapper">
        <img src="@/assets/p4.png" alt="" class="thumbnail">
        <h3 class="title">GIFT CARD 150€</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">TOP 2</p>
      </div>
      <div class="wrapper">
        <img src="@/assets/p4.png" alt="" class="thumbnail">
        <h1></h1>
        <h3 class="title">GIFT CARD 100€</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">TOP 3</p>
      </div>
    </div>
  </div>
  <div class="container-wrapper">
    <img src="@/assets/PremiosOnline.svg" alt="" class="heading">
    <div class="content">
      <div class="wrapper">
        <h3 class="content" style="font-size: 32px; color: white">Torneo Online de PS4 – Máximo de 128 jugadores.</h3><br>
        <h3 class="content" style="font-size: 32px; color:white; padding-bottom: 32px">Cuartos de final, Semifinal y Final se jugarán en Diagonal Mar – Planta Baja - Plaza Central</h3><br>
      </div>
    </div>
    <div class="content" style="text-align: center">
      <div class="wrapper">
        <img src="@/assets/p4.png" alt="" class="thumbnail">
        <h3 class="title"> GIFT CARD 250€</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">1º Lugar</p>
      </div>
    </div>
    <div class="content" style="text-align: center">
      <div class="wrapper">
        <img src="@/assets/p4.png" alt="" class="thumbnail">
        <h3 class="title"> GIFT CARD 150€</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">2º Lugar</p>
      </div>
      <div class="wrapper">
        <img src="@/assets/p4.png" alt="" class="thumbnail">
        <h3 class="title">GIFT CARD 100€</h3>
        <p style="padding-top: 22px; color: white; font-size: 22px">3º Lugar</p>
      </div>
    </div>

  </div>

</template>

<script>
export default {}
</script>

<style lang="scss" scoped>

.container-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 90px 20px;
  background: #012A2D;
  @media only screen and (max-width: 780px) {
    padding: 50px 10px;
  }

  img.heading {
    @media only screen and (max-width: 580px) {
      min-width: 400px;
    }
  }

  .heading {
    margin-bottom: 80px;
    @media only screen and (max-width: 980px) {
      margin-bottom: 40px;
      width: 280px;
    }
    @media only screen and (max-width: 780px) {
      margin-bottom: 30px;
      width: 340px;
    }
  }

  .content {
    display: flex;
    align-items: flex-start;
    justify-content: center;

    text-align: center;

    & > *:not(:last-child) {
      margin-right: 150px;
      @media only screen and (max-width: 1140px) {
        margin-right: 50px;
      }
      @media only screen and (max-width: 580px) {
        margin-right: 20px;
      }
    }

    .wrapper {
      .thumbnail {
        width: 250px;
        margin-bottom: 28px;
        clip-path: polygon(50% 0%, 100% 20%, 100% 75%, 50% 100%, 0 75%, 0 20%);
        @media only screen and (max-width: 980px) {
          width: 180px;
        }
        @media only screen and (max-width: 780px) {
          margin-bottom: 18px;
          width: 120px;
        }
        @media only screen and (max-width: 780px) {
          margin-bottom: 15px;
          width: 80px;
        }
      }

      .title {
        font-family: 'Lato';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        text-align: center;
        color: #FFFFFF;
        text-transform: capitalize;
        @media only screen and (max-width: 980px) {
          font-size: 20px;
        }
        @media only screen and (max-width: 780px) {
          font-size: 14px;
        }


      }

      .button {
        width: 308px;
        height: 44px;
        background: #0092bc;
        border: none;
        transition: all .2s;
        cursor: pointer;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #012A2D;
        margin-bottom: 40px;
        @media only screen and (max-width: 740px) {
          width: 270px;
        }

        &:active {
          transform: scale(0.95);
        }

        &:hover {
          box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05);
        }
      }

    }
  }

}

</style>